import { render, staticRenderFns } from "./albertprod.vue?vue&type=template&id=440045b9&"
import script from "./albertprod.vue?vue&type=script&lang=js&"
export * from "./albertprod.vue?vue&type=script&lang=js&"
import style0 from "./albertprod.vue?vue&type=style&index=0&id=440045b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports